import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function RomoniaCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-romonia"
      eyebrow="Selected work"
      tag="Brand Identity"
      title="Romonia — ROMANA Premium Olive Oil"
      summary="Identity and packaging visuals for a premium olive oil line: a botanical mark, confident typography, and a clean bottle treatment that reads natural, upscale, and retail-ready."
      image="/Romana_main.png"
      imageAlt="ROMANA premium olive oil — split layout with identity and bottle mockup"
      secondaryImage="/Romonia.png"
      secondaryImageAlt="ROMANA olive oil — additional brand and product visual"
      sections={[
        {
          title: "The brief",
          body: "Create a premium food brand feel—natural, trustworthy, and memorable—while keeping the system simple enough to reproduce consistently across labels, photography, and marketing.",
        },
        {
          title: "The identity",
          body: "A refined logo mark paired with strong typographic hierarchy and a restrained palette: deep olive, warm gold, and soft cream—supporting clarity on packaging and in digital layouts.",
        },
        {
          title: "Deliverables",
          body: "Brand-forward mockups that show how the identity scales from mark to full bottle presentation—helping stakeholders visualize the final shelf experience.",
        },
      ]}
      tech={["Adobe Illustrator", "Adobe Photoshop", "Brand Identity", "Packaging Mockups"]}
      results={[
        "Premium shelf presence",
        "Cohesive mark + type system",
        "Natural, upscale palette",
        "Print-ready visual direction",
      ]}
    />
  )
}
